module.exports = __webpack_public_path__ + "img/c08_buildingtechsilkweaving_Normal_ua.4843481e.webp";